/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
  tag: {
    width: 32,
    height: 32,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82zM7 7h.01"/>',
  },
});
